import {
  getExamEventDetailsData,
  useExamEventDetails,
  useSessionManagement,
} from '@exam-center/exam-event-management';
import {
  ExamType,
  FilterOperator,
  OrderType,
  useSearchExamCenterCoursesQuery,
} from '@exam-center/graphql';
import { Loading } from '@shared/components';

import { ExamEventReadonlyFields } from '../../components';

export default function ExamEventReadonlyDetails() {
  const { examEvent } = useExamEventDetails();

  const { examCourses, examType, registrationType, examineeImportMethod, room } =
    getExamEventDetailsData(examEvent);

  const { sessions, totalDuration } = useSessionManagement(examEvent.sessions);

  const { data: examCenterCoursesData, loading: isLoadingExamCenterCourses } =
    useSearchExamCenterCoursesQuery({
      variables: {
        searchExamCenterCoursesInput: {
          filter: {
            conditions: [
              {
                field: 'examCenterCode',
                operator: FilterOperator.Equal,
                value: examEvent.examCenterCode,
              },
            ],
          },
          paging: {
            currentPage: 0,
            pageSize: 200,
          },
          order: {
            type: OrderType.Asc,
            field: 'examId',
          },
        },
      },
      fetchPolicy: 'network-only',
    });

  const isAllExamCoursesSelected =
    examEvent.courses?.length === examCenterCoursesData?.ecSearchExamCenterCourses.total;

  if (isLoadingExamCenterCourses) {
    return <Loading sx={{ height: '100dvh' }} />;
  }

  return (
    <ExamEventReadonlyFields
      slotProps={{
        examCourses: {
          isAllSelected: isAllExamCoursesSelected,
          courses: examCourses ?? [],
        },
        examDate: {
          eventStartDate: examEvent.registrationStartedAt,
          eventEndDate: examEvent.registrationEndedAt,
          examStartedAt: examEvent.examStartedAt,
          examEndedAt: examEvent.examEndedAt,
        },
        sessions: {
          data: examEvent.examType === ExamType.Computer ? sessions : [],
          totalDuration,
        },
        province: {
          province: examEvent.examLocation.province.nameTh,
          location: examEvent.examLocation.nameTh,
        },
        name: examEvent.name,
        numberOfExaminees: examEvent.numberOfExaminees ?? 0,
        examType: examType,
        registrationType: registrationType,
        examineeImportMethod: examineeImportMethod,
        room: {
          roomData: room
            ? room.map((room) => ({
                ...room,
                name: room.name,
              }))
            : [],
        },
        applicantGroup: {
          code: examEvent.metadata.applicantGroup?.code ?? '-',
          type: examEvent.metadata.applicantGroup?.type ?? '-',
        },
        status: {
          status: examEvent.registrationStatus,
          reason: examEvent.metadata.reason,
        },
        seat: examEvent.seat,
      }}
    />
  );
}
